import React from "react";
import LessonBlocksArrayEditor from "./LessonBlocksArrayEditor";

export default function LessonBlocksContainerEditor({
                                                  title = "Blocks",

                                                  // Simple API
                                                  value,
                                                  onChange,

                                                  // Existing API
                                                  container,
                                                  path,
                                                  updateAtPath,
                                              }) {

    const data = container ?? value ?? { blocks: [] };

    const blocks = data.blocks || [];

    const setBlocks = (nextBlocks) => {

        if (onChange) {
            onChange({
                ...data,
                blocks: nextBlocks,
            });
            return;
        }

        if (updateAtPath) {
            updateAtPath([...path, "blocks"], nextBlocks);
        }

    };

    return (
        <div className="d-grid gap-8 m-10">
            {title && <h3 className="mb-2">{title}</h3>}

            <LessonBlocksArrayEditor
                blocks={blocks}
                onChange={setBlocks}
            />
        </div>
    );
}